"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentWidget = void 0;
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const order_1 = require("shared/order");
const capitalize_string_1 = require("shared/util/capitalize-string");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./intent-widget.less");
const moment = require("moment");
const select_1 = require("client/components/material/select");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const columns = [
    {
        center: false,
        id: "site.displayName",
        label: "Pharmacy",
        numeric: false
    },
    {
        center: false,
        id: "patient.lastName",
        label: "Patient",
        numeric: false
    },
    {
        center: true,
        id: "inventory.ndc",
        label: "NDC",
        numeric: false
    },
    {
        center: true,
        id: "inventory.name",
        label: "Drug",
        numeric: false
    },
    {
        center: true,
        id: "NO_ACTION",
        label: "Inventory/Claim Qty",
        numeric: false
    }
];
let IntentWidget = class IntentWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "order.createDate";
        this.moveToTop = "";
        this.clickedElement = "";
        this._isMounted = false;
        this.intentCount = 0;
        this.siteId = 0;
        this.loadIntentClaims = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 100,
                order: this.order,
                siteId: this.siteId,
                sort: this.orderBy,
                start: 0
            };
            store_1.ordersStore.loadIntentClaims(options);
        });
        this.loadData = () => {
            this.loadIntentClaims();
        };
        this.updateIntentCount = () => {
            let { intentClaims: { value: claims = [] } } = store_1.ordersStore;
            if (store_2.usersStore.userProvider &&
                store_2.usersStore.userProvider.value &&
                store_2.usersStore.userProvider.value.userId === store_2.usersStore.user.value.id &&
                store_2.usersStore.user.value.siteUser &&
                !store_2.usersStore.user.value.siteAdmin) {
                claims = claims.filter(claim => claim.order.provider.userId === store_2.usersStore.user.value.id);
            }
            this.intentCount = claims.length;
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadIntentClaims();
        };
        this.handleIntentClaimClick = (orderId, claimId, enoughQty) => async () => {
            if (enoughQty) {
                await store_1.ordersStore.updateStatusAsPaid(orderId, claimId);
            }
            router_1.RouteManager.transitionTo(`../../claims/${orderId}`);
        };
        this.renderTableRow = (row, index) => {
            const { inventory, order } = row;
            const { patient, site } = order;
            const { siteId } = store_2.usersStore.user.value;
            const inventorysite = inventory.sites.find(inventorysite => inventorysite.siteId === siteId);
            const totalCountFromValidLots = inventorysite
                ? inventorysite.inventorySiteLots.reduce((cur, acc) => {
                    const isValidLot = acc.expirationDate
                        ? moment(acc.expirationDate).isAfter(moment())
                        : false;
                    if (isValidLot)
                        return cur + acc.quantity;
                    return cur;
                }, 0)
                : 0;
            const onHandQty = totalCountFromValidLots;
            const claimQty = row.quantity;
            const notEnoughQty = onHandQty > 0 ? onHandQty < claimQty : true;
            const patientName = `${patient.lastName}, ${patient.firstName}`;
            const inventoryName = inventory.name;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, className: `row-color-accent--${notEnoughQty ? "red" : "green"}`, onClick: this.handleIntentClaimClick(order.id, row.id, !notEnoughQty) },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(site.displayName || site.name || "No site name") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(patientName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: inventory.ndc }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "qty-ratio", primary: `${onHandQty}/${claimQty}` })));
        };
        this.renderTable = () => {
            let { intentClaims: { value: claims = [] } } = store_1.ordersStore;
            if (store_2.usersStore.userProvider &&
                store_2.usersStore.userProvider.value &&
                store_2.usersStore.userProvider.value.userId === store_2.usersStore.user.value.id &&
                store_2.usersStore.user.value.siteUser &&
                !store_2.usersStore.user.value.siteAdmin) {
                claims = claims.filter(claim => claim.order.provider.userId === store_2.usersStore.user.value.id);
            }
            return (React.createElement("div", { className: "intent-claims-list" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: claims || [], renderRow: this.renderTableRow })));
        };
        this.handleTableFilter = (status) => (event) => {
            event.preventDefault();
            event.stopPropagation();
            switch (status) {
                case order_1.OrderStatus.Ready:
                    this.clickedElement = kpi_element_1.KPIElementColor.Green;
                    break;
                case order_1.OrderStatus.Pending:
                    this.clickedElement = kpi_element_1.KPIElementColor.Yellow;
                    break;
                case order_1.OrderStatus.Intended:
                    this.clickedElement = kpi_element_1.KPIElementColor.Blue;
                    break;
                default:
                    break;
            }
            this.loadIntentClaims();
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
            this.loadData();
        };
        this.renderStats = () => (React.createElement("div", { className: "orders__stats" },
            React.createElement("div", { className: "orders__stats--click", onClick: this.handleTableFilter(order_1.OrderStatus.Intended) },
                React.createElement("div", { className: "orders-list__status orders-list__status--9intended" }),
                " ",
                React.createElement("span", { className: `orders-list__status${this.moveToTop === "9intended" ? "--label-selected" : "--label"}` }, "Intent:"),
                " ",
                this.intentCount)));
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    get availableOptions() {
        // const options: IMenuItem[] = [];
        // const isImbUser = usersStore.user.value.user;
        // if (isImbUser) {
        //   if (sitesListStore.sites.value) {
        //     sitesListStore.sites.value.forEach((site, i) => {
        //       const indexStandardizer = 1;
        //       options.push({
        //         id: i + indexStandardizer,
        //         label: site.displayName || site.name,
        //         value: site.id.toString()
        //       });
        //     });
        //   }
        // } else {
        //   const { site } = usersStore.user.value;
        //   const siteOption = {
        //     id: site.id,
        //     label: site.displayName ?? site.name,
        //     value: site.id.toString()
        //   };
        //   options.push(siteOption);
        // }
        // if (isImbUser) {
        //   options.unshift({
        //     id: 0,
        //     label: "All pharmacies",
        //     value: "0"
        //   });
        // }
        const user = store_2.usersStore.user.value || null;
        const showAllSites = store_2.usersStore.permissions.ReadPharmacies;
        const options = store_3.sitesListStore.sites.value.filter(site => showAllSites || site.id === user.site.id || user.sites.includes(site.id))
            .map((site, i) => ({
            id: i + 1,
            label: site.displayName || site.name,
            value: String(site.id)
        }));
        if (true) {
            options.unshift({
                id: 0,
                label: "All pharmacies",
                value: "0"
            });
        }
        return options;
    }
    componentDidUpdate() {
        this.updateIntentCount();
    }
    async componentDidMount() {
        this._isMounted = true;
        this.siteId = store_2.usersStore.user.value.siteId;
        const options = {
            count: 100,
            order: this.order,
            siteId: this.siteId,
            sort: this.orderBy,
            start: 0
        };
        await store_1.ordersStore.loadIntentClaims(options);
        this.updateIntentCount();
        this.listIntentClaimsInterval = window.setInterval(() => {
            if (this._isMounted) {
                this.loadData();
            }
        }, 15000);
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.clearInterval(this.listIntentClaimsInterval);
    }
    render() {
        return (React.createElement("div", { className: "claims-widget widget" }, store_2.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "intent-widget-site-select-container" },
                React.createElement(select_1.MaterialSelect, { className: "intent-widget-site-select", options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" })),
            this.renderStats(),
            React.createElement("div", null, store_1.ordersStore.orders.value && this.renderTable()))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "moveToTop", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "clickedElement", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "listIntentClaimsInterval", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "_isMounted", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "intentCount", void 0);
__decorate([
    mobx_1.observable
], IntentWidget.prototype, "siteId", void 0);
__decorate([
    mobx_1.computed
], IntentWidget.prototype, "availableOptions", null);
IntentWidget = __decorate([
    mobx_react_1.observer
], IntentWidget);
exports.IntentWidget = IntentWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/intent-widget/intent-widget.tsx
// module id = 3354
// module chunks = 0